import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import {
  distinctUntilChanged,
  exhaustMap,
  filter,
  map,
  take,
  takeUntil,
} from 'rxjs/operators';
import { OrganizationService } from '../../../organizations/organization.service';
import { Organization, Tax } from '../../../shared/sdk';
import { TaxAddComponent } from '../../../taxes/tax-add/tax-add.component';
import { TaxService } from '../../../taxes/tax.service';

@Component({
  selector: 'app-document-item-tax',
  templateUrl: './document-item-tax.component.html',
  styleUrls: ['./document-item-tax.component.css'],
})
export class DocumentItemTaxComponent implements OnInit, OnDestroy {
  @Input() fGroup: FormGroup;
  @Input() class: string;
  taxes$: Observable<Tax[]>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private modalService: NgbModal,
    private orgService: OrganizationService,
    private taxService: TaxService,
  ) {}

  ngOnInit(): void {
    this.taxes$ = this.getTaxes();

    this.fGroup.valueChanges
      .pipe(
        // tap(val => console.log(val)),
        filter((val: any) => val.taxId === 'newTax'),
        takeUntil(this.onDestroy$),
      )
      .subscribe(() => this.openAddTaxModal());

    this.fGroup.valueChanges
      .pipe(
        // tap(val => console.log(val)),
        filter(
          (val: any) =>
            val.taxId === '' && this.fGroup.controls.rate.value !== 0,
        ),
        takeUntil(this.onDestroy$),
      )
      .subscribe(() => this.fGroup.controls.rate.setValue(0));

    // Populate rate form control based on selected tax
    this.fGroup.valueChanges
      .pipe(
        // tap(val => console.log(val)),
        filter(
          (val: any) => val.taxId !== 'newTax' && !!this.fGroup.controls.rate,
        ),
        map((val) => val.taxId),
        distinctUntilChanged(),
        exhaustMap(() => this.getTaxes()),
        map((taxes: Tax[]) =>
          taxes.find((t) => t.id === this.fGroup.controls.taxId.value),
        ),
        filter((tax) => !!tax),
        takeUntil(this.onDestroy$),
      )
      .subscribe((tax) =>
        this.fGroup.controls.rate.setValue(tax._taxRates[0].rate),
      );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private getTaxes(): Observable<Tax[]> {
    return this.orgService.active.pipe(
      exhaustMap((activeOrg: Organization) =>
        this.taxService.getAll(activeOrg.id),
      ),
      map(({ body }) => body),
      take(1),
    );
  }

  private openAddTaxModal(): void {
    const modalRef = this.modalService.open(TaxAddComponent, {
      size: 'sm',
    });

    modalRef.result
      .then((t: Tax) => {
        const tax = !!t ? JSON.parse(JSON.stringify(t)) : false;

        if (!tax) {
          this.fGroup.patchValue({ taxId: '' });
        } else {
          this.taxes$ = this.getTaxes();
          tax.taxId = tax.id;
          delete tax.id;
          tax.rate = tax._taxRates[0].rate;

          this.fGroup.patchValue(tax);
        }
      })
      .catch(() => {});
  }
}
